import { DocumentNode } from 'graphql'
import { withProps } from '../../utils/components'

const withQuery = (query: DocumentNode) => withProps({ query })

export default withQuery



// WEBPACK FOOTER //
// ./src/components/queries/withQuery.tsx